<div permission-display [module]="permission.cargo.module" [functionality]="permission.cargo.generateManifest" *ngIf="cargo?.state !== cargoStateEnum.CREATED 
        && cargo?.confirmedDriver">
    <!-- Button as mat-raised-button -->
    <button *ngIf="type === 'button-detail'" mat-raised-button color="primary" class="mx-0 mb-2"
        [disabled]="!canGenerateManifest()" [matTooltip]="!canGenerateManifest() ? documentRecreationInProgressMessage : ''"
        (click)="checkErrorToGenerateManifest()">
        {{documentRecreationInProgress ? 'Recreando manifiesto y remesas' : 'Generar manifiesto'}}
    </button>
    <!-- Tracking button -->
    <button *ngIf="type === 'button-tracking'" class="font-primary-light btn text-strong actions-card-primary-secondary"
        [disabled]="!canGenerateManifest()" [matTooltip]="!canGenerateManifest() ? documentRecreationInProgressMessage : ''"
        (click)="checkErrorToGenerateManifest()">
        <i class="fas" [ngClass]="documentRecreationInProgress ? 'fa-sync-alt fa-spin' : 'fa-file-alt'"></i>
        {{documentRecreationInProgress ? 'Recreando manifiesto y remesas' : 'Generar manifiesto'}}
    </button>

    <!-- Button as mat-menu-item -->
    <button *ngIf="type === 'cargo-option'" mat-menu-item [disabled]="!canGenerateManifest()"
        [matTooltip]="!canGenerateManifest() ? documentRecreationInProgressMessage : ''"
        (click)="checkErrorToGenerateManifest()">
        <i class="fas" [ngClass]="documentRecreationInProgress ? 'fa-sync-alt fa-spin' : 'fa-file-alt'"></i>
        {{documentRecreationInProgress ? 'Recreando manifiesto y remesas' : 'Generar manifiesto'}}
    </button>
</div>
